import { IMAGES, MANIFESTO } from "@/lib/site";
import { Reveal } from "@/components/site/Reveal";

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative bg-[#D9F4CD] py-24 md:py-40 border-t border-[#17320B]/10">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="flex items-center gap-4 mb-16 md:mb-24">
            <span className="font-mono-eb text-xs uppercase tracking-[0.3em] text-[#7B9C62]">/ The Why</span>
            <span className="h-px flex-1 bg-[#17320B]/15" />
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-[1.2fr_0.8fr] gap-16 lg:gap-24 items-start">
          <div className="space-y-16 md:space-y-24">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.no} delay={i * 0.05}>
                <div className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 items-start border-t border-[#17320B]/15 pt-8">
                  <span className="font-display text-5xl md:text-7xl text-[#17320B]/15">{m.no}</span>
                  <div>
                    <h3 className="font-display uppercase text-3xl md:text-5xl tracking-tight mb-4 text-[#17320B]">{m.title}</h3>
                    <p className="text-[#17320B]/65 text-base md:text-lg leading-relaxed max-w-xl">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15} className="lg:sticky lg:top-28">
            <div className="relative aspect-[3/4] overflow-hidden rounded-sm border border-[#17320B]/10">
              <img src={IMAGES.lifestyle} alt="Athlete fueling up" className="h-full w-full object-cover" />
              <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(23,50,11,0.75), transparent 50%)" }} />
              <div className="absolute bottom-0 left-0 p-6">
                <div className="font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#C2E9FF]">Recovery, redefined</div>
                <div className="font-display uppercase text-2xl mt-1 text-white">No slump. Just fuel.</div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
